import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';

import { reportError} from '../../../../../../../general_redux/notifications/actions';
import notificationEventType from '../../../../../../../config/data/notificationTypes';
import styles from './OtherEventsModal.module.css';


function OtherEventsModal(props) {
  
  const {
    mode,
    show,
    onHide,
    values,
  } = props;

  const dispatch = useDispatch();

  const rentals = useSelector(({ rentals }) => rentals && rentals.rentals);

  const targetName = mode === 'notification' ? 'Notification' : 'Activity';
  const bookingData = (values?.bookingData && values.bookingData[0]);
  const doubleBookingNumbers = bookingData?.doubleBookingNumbers;

  const getRentalNameById = (rentalId) => {
    return rentals.find(rental => rental.id === rentalId)?.name || 'N/A';
  };

  const handleReportError = () => {
    // NOTE: It should only be used in the notification modal
    dispatch(reportError(values.id));
    onHide();
  };

  const handleClose = () => {
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size='md'
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id='contained-modal-title-vcenter'
          className={styles.modalTitle}
        >
          {values?.message}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>
        { values?.type === notificationEventType.NEW_FEATURE_AVAILABLE && (
          <>
            <p>information about the new features</p>
            <div className={styles.modalButtonContainer}>
              <button
                onClick={handleClose}
                className={styles.grayButton}
              >
                Close
              </button>
            </div>
          </>
        )}
        { values?.type === notificationEventType.DOUBLE_BOOKING && (
          <>
            <div>
              <p>A double booking has been detected for {getRentalNameById(bookingData?.rentalId)}.</p>
              <p>Reservations affected:</p>
              <p>Reservation numbers {doubleBookingNumbers}.</p>
              <p>Next Steps:</p>
              <p style={{display: 'flex'}}>
                <div style={{paddingInline: '20px'}}>-</div><div>Review these bookings in the Reservations tab.</div>
              </p>
              <p style={{display: 'flex'}}>
                <div style={{paddingInline: '20px'}}>-</div><div>Decide how to proceed (cancel/amend).</div>
              </p>
              <p style={{display: 'flex'}}>
                <div style={{paddingInline: '20px'}}>-</div><div>If necessary, contact the relevant OTA to resolve the issue.</div>
              </p>
              { mode === 'notification' &&
                <p>Click on 'report error' to send this notification to the support team and receive more information on the case.</p>
              }
            </div>
            <div className={styles.modalButtonContainer}>
              { mode === 'notification' &&
                <button
                  onClick={handleReportError}
                  className={styles.greenButton}
                >
                  Report Error
                </button>
              }
              <button
                onClick={handleClose}
                className={styles.grayButton}
              >
                Close
              </button>
            </div>
          </>
        )}
        { values?.type === notificationEventType.OTA_CONNECTION_ERROR && (
          <>
              <p>
                <span>There was an error with Beehaz’s connection to an OTA.</span><br />
                <span>The Beehaz development team has already been notified of the error and shall investigate what happened.</span><br />
                { mode === 'notification' &&
                  <span>Click on ‘report error’ to re-send this notification to the support team, and receive an update on the case.</span>
                }
              </p>
              <div className={styles.modalButtonContainer}>
                { mode === 'notification' &&
                  <button
                    onClick={handleReportError}
                    className={styles.greenButton}
                  >
                    Report Error
                  </button>
                }
                <button
                  onClick={handleClose}
                  className={styles.grayButton}
                >
                  Close
                </button>
              </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default OtherEventsModal; 